import { dispatcher, ingenuity } from "@quest/base-core";
import { BaseGameState } from "@quest/murka-games-behavior-panther/dist/Game/State/BaseGameState";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { HoldAndReSpinView } from "../HoldAndReSpin/View/HoldAndReSpinView";
import { HoldAndReSpinLogic } from "../HoldAndReSpin/Controller/HoldAndReSpinLogic";
import { BehaviorCoreModule, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { StackSymbolFeatureControllerGame } from "../StackFeature/StackSymbolFeatureControllerGame";



export class BaseGameStateGame extends BaseGameState {
//
private bonusFeatureView: HoldAndReSpinView;
protected HoldAndReSpinLogic: HoldAndReSpinLogic;

protected subscribeEventsGame(): void {
    super.subscribeEventsGame();
    dispatcher.on(eventDispatchers.INITIALIZE_HOLD_AND_RESPIN, this.initializeHoldAndRespinFeature, this);
    dispatcher.on(eventDispatchers.DESTROY_HOLD_AND_RESPIN, this.destroyHoldAndRespin, this);
  }

  protected unSubscribeEvents(): void {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_HOLD_AND_RESPIN, this.initializeHoldAndRespinFeature, this);
    dispatcher.off(eventDispatchers.DESTROY_HOLD_AND_RESPIN, this.destroyHoldAndRespin, this);
  }

protected initializeHoldAndRespinFeature(): void {
    if (!this.bonusFeatureView) {
      this.bonusFeatureView = new HoldAndReSpinView(ingenuity.currentGame.cache.getJSON("main_data").holdAndReSpin);
      ingenuity.currentGame.stage.addChild(this.bonusFeatureView);
      this.HoldAndReSpinLogic = new HoldAndReSpinLogic(this.bonusFeatureView, this.model);
    }
  }
  protected destroyHoldAndRespin(): void {
    this.bonusFeatureView.destroy();
    this.bonusFeatureView = null;
    this.HoldAndReSpinLogic = null;
  }

  protected initializeStackSymbolFeature(): void {
    if (!this.stackSymbolView) {
      this.stackSymbolView = new BehaviorCoreModule.StackSymbolFeatureView(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).stackSym);
      this.stackSymbolController = new StackSymbolFeatureControllerGame(this.stackSymbolView);
      this.setLayering(this.stackSymbolView);
  }
  }
}
